import React, { useState, useRef } from 'react';
import { useForm, usePage } from '@inertiajs/react';
import { Alert } from '../../components/Alert';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { InputOTP, InputOTPGroup, InputOTPSlot } from '../../components/ui/input-otp';
import { useTrans } from '../../hooks/useTrans';
import AuthCard from '../../components/layout/auth/AuthCard';

export default function MfaAuthenticator() {
    const translate = useTrans();
    const { flash } = usePage().props;
    const [isBackupMode, setIsBackupMode] = useState(false);

    const { data, setData, post, processing } = useForm({
        mfa_code: '',
        multi_factor_authentication_type: 'authenticator',
    });

    function handleSubmit(e) {
        e.preventDefault();
        post('/login');
    }

    function toggleMode(e) {
        e.preventDefault();
        setIsBackupMode(!isBackupMode);
        setData({
            mfa_code: '',
            multi_factor_authentication_type: isBackupMode ? 'authenticator' : 'backup_code',
        });
    }

    return (
        <AuthCard title={translate('Bevestig je inlogverzoek')} backLink="/login">
            {flash && flash.type === 'error' && (
                <Alert variant="error">{flash.description}</Alert>
            )}

            <p>
                {isBackupMode
                    ? translate('Voer hieronder een van je herstelcodes in om in te loggen. Deze herstelcodes zijn bedoeld voor noodgevallen wanneer je geen toegang hebt tot je authenticator-app. Elke code kan slechts één keer worden gebruikt.')
                    : translate('Voer de verificatiecode in die door je authenticator-app is gegenereerd om in te loggen. Dit is ter verificatie en voor extra veiligheid.')
                }
            </p>

            <form onSubmit={handleSubmit} autoComplete="off" className="mt-4">
                <div className="space-y-4">
                    {isBackupMode ? (
                        <Input
                            value={data.mfa_code}
                            onChange={(e) => setData('mfa_code', e.target.value)}
                            placeholder={translate('Herstelcode')}
                            maxLength={10}
                            className="h-[44px] font-normal"
                        />
                    ) : (
                        <div className="flex justify-center">
                            <InputOTP
                                maxLength={6}
                                value={data.mfa_code}
                                onChange={(value) => setData('mfa_code', value)}
                            >
                                <InputOTPGroup>
                                    <InputOTPSlot index={0} className="h-12 w-12 text-lg" />
                                    <InputOTPSlot index={1} className="h-12 w-12 text-lg" />
                                    <InputOTPSlot index={2} className="h-12 w-12 text-lg" />
                                    <InputOTPSlot index={3} className="h-12 w-12 text-lg" />
                                    <InputOTPSlot index={4} className="h-12 w-12 text-lg" />
                                    <InputOTPSlot index={5} className="h-12 w-12 text-lg" />
                                </InputOTPGroup>
                            </InputOTP>
                        </div>
                    )}

                    <Button variant="primary" type="submit" disabled={processing} className="w-full">
                        {isBackupMode
                            ? translate('Inloggen met herstelcode')
                            : translate('Inloggen met verificatiecode')
                        }
                    </Button>
                </div>
            </form>

            <div className="mt-4">
                <a href="#" onClick={toggleMode} className="text-sm text-[#003545] hover:underline">
                    {isBackupMode
                        ? translate('Inloggen met authenticator-app')
                        : translate('Geen toegang tot je authenticator-app?')
                    }
                </a>
            </div>
        </AuthCard>
    );
}
